import { render } from "./AppHeaderLinks.vue?vue&type=template&id=413a946c&scoped=true"
import script from "./AppHeaderLinks.vue?vue&type=script&lang=js"
export * from "./AppHeaderLinks.vue?vue&type=script&lang=js"

import "./AppHeaderLinks.vue?vue&type=style&index=0&id=413a946c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413a946c"]])

export default __exports__